import { app } from '@/app';
import { initSentry } from '@/app/services';
import { router } from '@/router';

router.isReady().then(async () => {
  console.log('[router] router is ready');

  await initSentry(app, router);

  app.mount('#app');
});
